import { render } from "./ProfilePage.vue?vue&type=template&id=443a15e1&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"

import "./ProfilePage.vue?vue&type=style&index=0&id=443a15e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443a15e1"]])

export default __exports__